import React, {useEffect, useState} from 'react';
import { Modal } from 'antd';
import axios from '../Common/axios';
import InfoTable from './InfoTable';
import {threatColumnData} from './columns';
import {getFindInfoThreatListData, postSaveVaThreatData} from '../Common/api';

import {threatListData} from '../Common/tempData';

function InfoThreat({reportId}) {

    const [dataSource, setDataSource] = useState(threatListData);
    //const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const titleName="위협 등록";

    useEffect(() => {
        //자동조회
        if(reportId) {
            findInfoThreatListData();
        }
    }, []);

    const findInfoThreatListData = () => {
        // 보고서ID 필수조건 체크
        if (reportId == '') {
            Modal.info({title: "Report ID가 누락 되었습니다."});
            return;
        }

        setIsLoading(true);
        axios.get(getFindInfoThreatListData(reportId))
            .then((response) => {
                setIsLoading(false);
                
                setDataSource(response.data);
                // const resDataLine = response.data.map(item => {
                //     return {
                //         ...item,
                //         suggest_desc: item.suggest_desc.replaceAll(/(\\n|\n)/g, "<br />")
                //     };
                // });
                // setDataSource(resDataLine);

                //if(response.data.totalCount == 0) {
                //    Modal.info({title: "조회된 결과가 없습니다.", okText:"닫기"});
                //} 
            })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    // 저장 클릭 시
    const onClickSaveHandler = (saveData) => {

        // 변경건이 있으면 추가
        if(saveData.length > 0) {
            saveCheckList(saveData);
        } else {
            Modal.info({title:titleName, content:"변경된 데이타가 없습니다.", okText:"Close"});
        }

    }

    // 등록/수정/삭제 API
    const saveCheckList = (saveData) => {

        axios.post(postSaveVaThreatData()
                        , {reportId : reportId, saveData : saveData}
                        , {logType:'/edit/TemplateThreat/', logParam : reportId})
        .then((response) => {
            //console.log(response);
            //Modal.info({title: "OK.", okText:"Close"});
            if(response.data == '000') {
                Modal.info({title:titleName, content:"데이터가 정상적으로 등록 되었습니다.", okText:"Close"});
            } else {
                Modal.info({title:titleName, content:response.data, okText:"Close"});  
            }

            //재조회
            findInfoThreatListData();
        })
        .catch((error) => {
            Modal.error({title:titleName, content:error.message, okText:"Close"});
        });
    };

    // 정보 변경시 재조회
    const onReloadHandler = () => {
        //재조회
        findInfoThreatListData();
    }
    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <div className='tab_content'>
                 <InfoTable
                    data={dataSource} 
                    columnData={threatColumnData}
                    reportId={reportId}
                    infoType={'threat'}
                    rowkey="id"
                    isLoading={isLoading} 
                    onClickSaveHandler={onClickSaveHandler}
                    onReloadHandler={onReloadHandler}
                    fullHeight={!!window.opener}/>
            </div>
        </>
    );
}

export default InfoThreat;